import { useSelector } from 'react-redux';
import { Role } from '@algoan/dashboard/model';
import { selectUserInformation } from '@algoan/dashboard/store/selectors';

export const useAccessControl = (rolesSearched: Role[]): boolean => {
  const userInformation = useSelector(selectUserInformation);
  const hasValidRole = userInformation?.roles?.some((role: Role) => rolesSearched.includes(role));

  return !!hasValidRole;
};
